import { render, staticRenderFns } from "./areaAcademyVideoList.vue?vue&type=template&id=24e3b941&scoped=true"
import script from "./areaAcademyVideoList.vue?vue&type=script&lang=js"
export * from "./areaAcademyVideoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3b941",
  null
  
)

export default component.exports